import { ReactNode } from 'react';
import { Box, Text } from '@chakra-ui/react';

/**
 * `Warning` コンポーネント
 * 
 * このコンポーネントは、警告メッセージを表示するためのカスタムコンポーネントです。
 * `children` プロパティを使用して、表示したいメッセージを動的に指定できます。
 * 
 * @param {ReactNode} children - 表示する警告メッセージ。
 * 
 * @returns JSX 要素（警告ボックス）。
 */


type Props = {
    children: ReactNode;  // ReactNode 型で children を受け取る
}

const Warning: React.FC<Props> = ({ children }) => {
    return (
        <Box
            position="absolute"
            top="10%"
            left="50%"
            transform="translateX(-50%)"
            zIndex="20"
            bg="linear-gradient(135deg, rgba(255, 0, 0, 0.9), rgba(255, 70, 70, 0.8))"
            p={6}
            borderRadius="xl"
            boxShadow="0 4px 12px rgba(0, 0, 0, 0.2)"
            opacity="0"
            animation="fadeIn 1s ease-in-out forwards"
            className="warning-box"
        >
            <Text
                color="white"
                fontSize="xl"
                fontWeight="bold"
                textAlign="center"
                textShadow="2px 2px 4px rgba(0, 0, 0, 0.5)"
            >
                {children}
            </Text>
        </Box>
    );
};

export default Warning;